import "./user_list.page.style.scss";
import "./user_list.page.style.scss";
import { FC } from "react";
import KeyWordLocalization from "../../../utils/KeyWordLocalization";
import PaginatorComponent from "../../../components/paginator/PaginatorComponent";
import useUserListViewModel from "./user_list.page.view_model";
import LayoutComponent from "../../../layouts/layoutComponent/LayoutComponent";
import { UserType } from "../../../../domain/entities/UserEntity";
import ButtonComponent from "../../../components/button/ButtonComponent";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent";
import NotResultsComponent from "../../../components/noResults/NoResultsComponent";
import EntitiesConstants from "../../../utils/EntitiesConstants";

const UserListPage: FC<{}> = () => {
    const {
        formInfo,
        result,
        loadingDownload,
        i18n,
        _handleSearch,
        _handleChangeTextSearch,
        _handleChange,
        _handleOnChangePage,
        _handleOnClickDeleteAgent,
        _handleOnClickUpdateAgent,
        _handleOnCreateSingleAgent,
    } = useUserListViewModel();

    const { register, handleSubmit } = formInfo;


    return <div className="user_list_page">
        <LayoutComponent title={i18n("Usuarios")}>
            <div className="container py-5">
                <form onSubmit={handleSubmit(_handleSearch)}>
                    <div className="row">
                        <div className="col-md-8">
                            <input type="text" className="form-control" placeholder={i18n(KeyWordLocalization.UserListPageSearchInput)} {...register(KeyWordLocalization.UserListPageQuery)} onKeyUp={_handleChangeTextSearch} />
                        </div>
                        <div className="col-md-2">
                            <select className="form-control" {...register(KeyWordLocalization.UserListPageRoleQuery, { onChange: _handleChange })} >
                                <option value="">{i18n("Cualquier rol")}</option>
                                <option value={UserType.ADMIN}>{i18n("Administrador")}</option>
                                <option value={UserType.SUPERVISOR}>{i18n("Supervisor")}</option>
                                <option value={UserType.VALET}>{i18n("Valet")}</option>
                            </select>
                        </div>
                        <div className="col-md-2">
                            <ButtonComponent
                                className="w-100 d-flex justify-content-center"
                                icon={<span className="material-symbols-outlined">search</span>}
                                text={i18n(KeyWordLocalization.UserListPageSearch)} design="primaryOutline" type="submit" />
                        </div>
                    </div>
                    <div className="w-100 d-flex justify-content-end mt-3">
                        <ButtonComponent
                            design="primaryOutline"
                            onClick={_handleOnCreateSingleAgent}
                            icon={<span className="material-symbols-outlined">add</span>}
                            className="btn_bulk_import"
                            text={i18n(KeyWordLocalization.UserListPageAddUser)}
                        />
                    </div>

                    <div className="list">
                        {result == undefined && <div className="mt-5">
                            <LoadingComponent />
                        </div>}
                        {result && result.data.length == 0 && <NotResultsComponent />}
                        {result && result.data.length > 0 && <table className="table my-3" style={{ tableLayout: "auto" }}>
                            <thead>
                                <tr>
                                    <th>{i18n(EntitiesConstants.UserEntityId)}</th>
                                    <th>{i18n(EntitiesConstants.UserEntityName)}</th>
                                    {/* <th>{i18n(EntitiesConstants.UserEntityDocument)}</th> */}
                                    <th>{i18n(EntitiesConstants.UserEntityPhone)}</th>
                                    <th>{i18n(EntitiesConstants.UserEntityRole)}</th>
                                    <th>{i18n(KeyWordLocalization.UserListPageActions)}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {result.data.map((agent, index) => <tr key={index}>
                                    <td className="hover"  style={{ width: 10 }}>
                                        {agent.id}
                                    </td>
                                    <td className="hover" >
                                        {agent.name}
                                    </td>
                                    {/* <td className="hover" >
                                        {agent.document}
                                    </td> */}
                                    <td className="hover" >
                                        {agent.phone}
                                    </td>
                                    <td className="hover" >
                                        {agent.role}
                                    </td>
                                    <td style={{ width: '15em' }}>
                                        <div className="d-flex">
                                            <ButtonComponent
                                                onClick={() => _handleOnClickUpdateAgent(agent)}
                                                className="mx-2"
                                                design="primaryOutline"
                                                icon={<span className="material-symbols-outlined">edit</span>}
                                            />
                                            <ButtonComponent
                                                onClick={() => _handleOnClickDeleteAgent(agent)}
                                                design="dangerOutline"
                                                type="button"
                                                icon={<span className="material-symbols-outlined">delete</span>}
                                            />
                                        </div>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>}
                    </div>
                    <div className="paginator">
                        {result && result.pages > 1 &&
                            <PaginatorComponent resultData={result} onChangePage={_handleOnChangePage} />
                        }
                    </div>
                </form>
            </div>
        </LayoutComponent>
    </div>
}

export default UserListPage;